import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarCheck4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendarCheck4"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15.5V4H8.5V2H7V4ZM15.9167 10.575L10.9 15.5917L8.08328 12.775L9.25 11.6083L10.9 13.2583L14.75 9.40829L15.9167 10.575Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarCheck4;
